import request from "@/api/request";


// 获取用户信息
export function getUserInfoApi() {
    return request({
        url: "/v4/users/me",
        method: "get"
    });
}
// 获取数量
export function getCountApi() {
    return request({
        url: "/v4/user/me",
        method: "get"
    });
}
// 店铺列表
export function shopList(query:any) {
    return request({
        url: "/v4/users/newShopList",
        method: "get",
        params: query
    });
}


// 选择店铺
export function shopSelect(query:any) {
    return request({
        url: "/v4/users/shop",
        method: "post",
        data: query,
        formData: true
    } as any);
}

// 获取预存款
export function getPreDepositApi(query:any) {
    return request({
        url: "/v4/user/bill/info",
        method: "get",
        params: query
    });
}

// 退出登录
export function logoutApi() {
    return request({
        url: "/v4/account/signout",
        method: "post"
    });
}


// 获取分公司
export function getCompanyList() {
    return request({
        url: "/v4/users/switch/companyList",
        method: "get"
    });
}

// 获取配送中心
export function getDeliverList(params:any) {
    return request({
        url: "/v4/users/switch/deliverList",
        method: "get",
        params: params
    });
}

// 购物车数量
export function getCartNum() {
    return request({
        url: "/v4/cart/count",
        method: "get"
    });
}